import { useParams } from "react-router-dom";
import { Listbox, ListboxItem, Card, CardBody } from "@nextui-org/react";

import { logos } from "cvpop-assets-sdk"
import { t } from "cvpop-localization-sdk"

import _ from "lodash"

import { useColorScheme } from "../../../controllers/hooks"
import { openUrl } from "../../../controllers/app"

import WebListItemHeaderView from "../../molecules/views/WebListItemHeaderView";


const openSourceLibraries = [{
    name: "react-markdown",
    copyright: "Copyright (c) 2015 Espen Hovlandsdal",
    url: "https://github.com/remarkjs/react-markdown",
    license: "MIT license"
}, {
    name: "nextui",
    copyright: "Copyright (c) 2020 Next UI",
    url: "https://github.com/nextui-org/nextui",
    license: "MIT license"
}, {
    name: "react-redux",
    copyright: "Copyright (c) 2015-present Dan Abramov",
    url: "https://github.com/reduxjs/react-redux",
    license: "MIT license"
}, {
    name: "redux",
    copyright: "Copyright (c) 2015-present Dan Abramov",
    url: "https://github.com/reduxjs/redux",
    license: "MIT license"
}, {
    name: "browser-image-compression",
    copyright: "Copyright (c) 2019 Donald Chan",
    url: "https://github.com/Donaldcwl/browser-image-compression",
    license: "MIT license"
}, {
    name: "firebase-js-sdk",
    url: "https://github.com/firebase/firebase-js-sdk/tree/master",
    license: "Apache-2.0"
}, {
    name: "motion",
    copyright: "Copyright (c) 2018 Framer B.V.",
    url: "https://github.com/framer/motion",
    license: "MIT license"
}, {
    name: "immer",
    copyright: "Copyright (c) 2017 Michel Weststrate",
    url: "https://github.com/immerjs/immer",
    license: "MIT license"
}, {
    name: "localForage",
    url: "https://github.com/localForage/localForage",
    license: "Apache-2.0"
}, {
    name: "match-sorter",
    copyright: "Copyright (c) 2020 Kent C. Dodds",
    url: "https://github.com/kentcdodds/match-sorter",
    license: "MIT license"
}, {
    name: "moment",
    copyright: "Copyright (c) JS Foundation and other contributors",
    url: "https://github.com/moment/moment/",
    license: "MIT license"
}, {
    name: "react",
    copyright: "Copyright (c) Meta Platforms, Inc. and affiliates.",
    url: "https://github.com/facebook/react/",
    license: "MIT license"
}, {
    name: "react-advanced-cropper",
    copyright: "Copyright (c) Norserium, https://github.com/Norserium",
    url: "https://github.com/advanced-cropper/react-advanced-cropper",
    license: "MIT license"
}, {
    name: "react-colorful",
    copyright: "Copyright (c) 2020 Vlad Shilov <omgovich@ya.ru>",
    url: "https://github.com/omgovich/react-colorful",
    license: "MIT license"
}, {
    name: "react-lottie",
    url: "https://github.com/chenqingspring/react-lottie",
    license: "MIT license"
}, {
    name: "react-quill",
    copyright: "Copyright (c) 2020, zenoamaro <zenoamaro@gmail.com>",
    url: "https://github.com/zenoamaro/react-quill",
    license: "MIT license"
}, {
    name: "react-router",
    copyright: "Copyright (c) React Training LLC 2015-2019 Copyright (c) Remix Software Inc. 2020-2021 Copyright (c) Shopify Inc. 2022-2023",
    url: "https://github.com/remix-run/react-router",
    license: "MIT license"
}, {
    name: "react-signature-canvas",
    copyright: "Copyright (c) 2016 Anton Gilgur",
    url: "https://github.com/agilgur5/react-signature-canvas",
    license: "Apache-2.0"
}, {
    name: "redux-persist",
    copyright: "Copyright (c) 2017 Zack Story",
    url: "https://github.com/rt2zz/redux-persist",
    license: "MIT license"
}, {
    name: "sort-by",
    copyright: "Copyright (c) 2014 River Grimm river.grimm@gmail.com",
    url: "https://github.com/kvnneff/sort-by",
    license: "MIT license"
}]



const WebCredits = () => {

    // ------------------------------------------------------------------------------------------------------------------------
    const { platform } = useParams()

    // ------------------------------------------------------------------------------------------------------
    const cs = useColorScheme()

    // ------------------------------------------------------------------------------------------------------
    return (
        <div className="md:w-full p-8">

            <div className="flex items-center justify-center">
                <img alt="Freepik logo" src={logos.freepik} className="mr-4 max-w-32" />
                <div>
                    <p>
                        <span>Icons and logos made by </span>
                        <a href="#" onClick={() => openUrl("https://www.freepik.com", platform)} className="text-primary">Freepik</a>
                        <span> from </span>
                        <a href="#" onClick={() => openUrl("https://www.flaticon.com", platform)} className="text-primary">www.flaticon.com</a>
                    </p>
                </div>
            </div>

            <div className="flex items-center  justify-center mt-4">
                <img src={logos.storyset[cs]} className="mr-4 max-w-32" />
                <div>
                    <p>
                        <span>People illustrations by </span>
                        <a href="#" onClick={() => openUrl("https://storyset.com/people", platform)} className="text-primary">Storyset</a>
                    </p>
                </div>
            </div>

            <div className="max-w-xl" style={{ margin: "0 auto" }}>
                <WebListItemHeaderView text={t('credits')} />
                <Card>
                    <CardBody>
                        <Listbox
                            aria-label="Actions"
                            onAction={k => openUrl(k, platform)}
                            variant={"flat"}
                        >
                            {_.orderBy(openSourceLibraries, 'name').map(e => (
                                <ListboxItem
                                    key={e.url}
                                    variant={"light"}
                                    title={e.name}
                                    description={e.license && e.copyright ? `${e.license} - ${e.copyright}` : (e.license || e.copyright)}
                                />
                            ))}
                        </Listbox>
                    </CardBody>
                </Card>
            </div>

        </div>
    )
}

export default WebCredits